import { DateTime } from 'luxon';

export const MAX_DATE_RANGE_MONTHS = 85;

export const validateDate = (
  dateStr: string,
  otherDateStr: string | null | undefined,
  dateType: 'startDate' | 'endDate',
): string | null => {
  if (dateStr?.length !== 10) return null;
  const parsed = DateTime.fromFormat(dateStr, 'MM/dd/yyyy');
  if (!parsed.isValid) return 'Enter a valid date';
  return (
    validateDateRange(parsed) ??
    validateDateOrder(parsed, otherDateStr, dateType)
  );
};

const validateDateRange = (parsed: DateTime): string | null => {
  const maxDate = DateTime.now().startOf('day');
  const minDate = DateTime.now()
    .minus({ months: MAX_DATE_RANGE_MONTHS })
    .startOf('day');
  if (parsed > maxDate) return 'Date cannot be in the future';
  if (parsed < minDate) return 'Date is outside the allowed range';
  return null;
};

const validateDateOrder = (
  parsed: DateTime,
  otherDateStr: string | null | undefined,
  dateType: 'startDate' | 'endDate',
): string | null => {
  if (otherDateStr?.length !== 10) return null;
  const parsedOther = DateTime.fromFormat(otherDateStr, 'MM/dd/yyyy');
  if (!parsedOther.isValid) return null;
  if (dateType === 'endDate' && parsed < parsedOther) {
    return 'End date cannot be before start date';
  }
  if (dateType === 'startDate' && parsed > parsedOther) {
    return 'Start date cannot be after end date';
  }
  return null;
};
